import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import vw from 'styles/utils';

function Container(props) {
  const { children } = props;

  return (
    <Root {...props}>{children}</Root>
  )
}

Container.propTypes = {
  children: PropTypes.any
}

const Root = styled.div`
  ${vw('padding-left', 15, 30, 80)}
  ${vw('padding-right', 15, 30, 80)}
`;

export default Container
